var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertIcon = function SvgAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.265 1.9a.857.857 0 0 0-1.525 0l-4.715 9.428a.857.857 0 0 0 .763 1.243h9.429a.856.856 0 0 0 .762-1.242l-4.714-9.43ZM7.502 5.285v2.786",
    stroke: "#865106",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.954 10.214a.498.498 0 0 0-.452-.714.714.714 0 1 0 0 1.429.5.5 0 0 0 .452-.715Z",
    fill: "#865106"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.002 10a.5.5 0 0 1 .5-.5.714.714 0 0 1 0 1.429.5.5 0 0 1-.452-.715.498.498 0 0 1-.048-.214Z",
    fill: "#865106"
  })));
};
export default SvgAlertIcon;